import { createElement, useEffect, useRef, useState } from 'react';
import 'intersection-observer';

const VisibilitySensor = ({
    tag = 'div',
    active = true,
    onChange = () => {},
    onVisible = () => {},
    children,
    offset = {},
    ...props
}) => {
    const domRef = useRef();
    const [isVisible, setVisible] = useState(false);
    const { top = 0, right = 0, bottom = 0, left = 0 } = offset;
    useEffect(() => {
        if (!active) {
            return;
        }
        const theRef = domRef.current;
        try {
            const observer = new IntersectionObserver(
                (entries) => {
                    const firstEntry = entries[0] || {};
                    setVisible(!!firstEntry.isIntersecting);
                },
                { rootMargin: `${top}px ${right}px ${bottom}px ${left}px` }
            );
            observer.observe(theRef);
            return () => observer.unobserve(theRef);
        } catch {}
    }, [top, right, bottom, left, active]);

    useEffect(() => {
        onChange(isVisible);
    }, [isVisible, onChange]);
    useEffect(() => {
        if (isVisible) {
            onVisible();
        }
    }, [onVisible, isVisible]);

    return createElement(tag, { ref: domRef, 'aria-busy': true, 'aria-live': 'polite', ...props }, children);
};

export default VisibilitySensor;
